/**
 * Component visibility editor (`visible_when`) — a thin page-builder wrapper over
 * the shared `ConditionEditor`: `{{ }}` templates (braces), with the page
 * `ExpressionField` (IntelliSense + live preview) as the Expression-mode editor.
 * The same `ConditionEditor` powers the workflow `filter`/`if` predicate fields.
 */
import type { ValueType } from "@/lib/conditionExpr";
import { ExpressionField, type ExprPreviewFn } from "@/components/workflows/ExpressionField";

import { ConditionEditor } from "./ConditionEditor";

export function VisibilityEditor({
  value,
  onChange,
  exprAmbientDts,
  previewExpr,
  fields = [],
  fieldTypes = {},
}: {
  value: string;
  onChange: (expr: string) => void;
  exprAmbientDts?: string;
  previewExpr?: ExprPreviewFn;
  fields?: string[];
  fieldTypes?: Record<string, ValueType>;
}) {
  return (
    <ConditionEditor
      value={value}
      onChange={onChange}
      fields={fields}
      fieldTypes={fieldTypes}
      braces
      label="Show when"
      hint="Render this component only when the condition holds (always shown in the builder)."
      renderExpression={(v, oc) => (
        <ExpressionField
          value={v}
          onChange={oc}
          multiline
          jsAmbientTypes={exprAmbientDts}
          previewExpr={previewExpr}
        />
      )}
    />
  );
}
